export const API_BASE_URL = 'https://appli-gg-be.visamonde.com';
// https://appli-gg-be.visamonde.com  (prod)
// http://localhost:3001                         (dev)
